import React from "react";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import ContentLoader from "react-content-loader";

interface StyleProps {
  marginBottom?: number | string;
  image?: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  button: (props) => ({
    background: "#fff",
    borderRadius: 14,
    border: 0,
    color: "#000",
    height: 154,
    display: "flex",
    marginBottom: props.marginBottom,
    boxShadow: "0 6px 6px 0 #a28ac933",
    padding: 21,
    textTransform: "none",
    backgroundImage: `url(${props.image})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right",
    flexDirection: "column",
    alignItems: "flex-start",
    "&:disabled": {
      backgroundColor: "#616161",
      color: "#C4C4C4",
    },
    "&:focus": {
      backgroundColor: "#fff",
    },
    "&:hover": {
      backgroundColor: "#EBEBEB",
      // `breakpoints.mobile` no existe: el valor está en `breakpoints.values.mobile`,
      // así que la key queda `undefined` y este bloque nunca se aplica. Ver SEG-1519.
      [(theme.breakpoints as any).mobile]: {
        backgroundColor: "#fff",
      },
    },
  }),
  buttonLabel: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-end",
  },
  buttonIcon: {
    width: 31,
    height: 31,
    marginBottom: 35,
  },
}));

interface SingleButtonProps {
  isLoading?: boolean;
  onClick?: () => void;
  icon?: string;
  image?: string;
  label?: React.ReactNode;
  subLabel?: React.ReactNode;
  marginBottom?: number | string;
  disabled?: boolean;
}

const SingleButton: React.FC<SingleButtonProps> = ({
  isLoading,
  onClick,
  icon,
  image,
  label,
  subLabel,
  marginBottom,
  disabled,
}) => {
  const classes = useStyles({
    marginBottom,
    image,
  });
  const theme = useTheme();
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      variant="contained"
      size="large"
      color="primary"
      fullWidth
      className={classes.button}
      // `label` dejó de ser un slot de Button en MUI v5, así que este estilo
      // no llega a aplicarse. Se conserva tal cual; ver SEG-1521.
      classes={{ label: classes.buttonLabel } as any}
    >
      <img src={icon} alt="" className={classes.buttonIcon} />
      <Typography
        variant="caption"
        noWrap
        style={{
          fontWeight: "bold",
          lineHeight: "1.5",
          fontSize: theme.typography.pxToRem(20),
          letterSpacing: 0.2,
          textAlign: "left",
        }}
      >
        {label}
      </Typography>
      {!isLoading && (
        <Typography
          variant="caption"
          noWrap
          style={{
            fontWeight: 600,
            lineHeight: "1.5",
            fontSize: theme.typography.pxToRem(12),
            letterSpacing: 0.2,
            color: "#424242",
            textAlign: "left",
          }}
        >
          {subLabel}
        </Typography>
      )}
      {isLoading && (
        <ContentLoader
          speed={1}
          backgroundColor="#f7f8ff"
          foregroundColor="#B9A7D7"
          style={{ height: 20, width: "100%" }}
        >
          <rect x="0" y="0" rx="4" ry="4" width="40%" height="18" />
        </ContentLoader>
      )}
    </Button>
  );
};

export default SingleButton;
